import { useEffect, useRef } from "react";
import { LoginForm } from "../Forms/LoginForm";

export type PositionLoginPromptPopupProps = {
    applyingForID: number,
    candidateTitle: string,
    speculative: boolean,
    intranet: boolean,
    onCompleteCallback: (doLogic: boolean) => void,
}

export function PositionLoginPromptPopup(props: PositionLoginPromptPopupProps) {
    const handleEvent = () => {
        closeRef?.current?.click();
    };
    useEffect(() => {
        window.addEventListener("popstate", handleEvent);
        return () => window.removeEventListener("popstate", handleEvent);
    });
    const callback = (doLogic: boolean) => {
        closeRef?.current?.click();

        if (doLogic)
            props?.onCompleteCallback(doLogic);
    }

    const closeRef = useRef<HTMLButtonElement>(null);

    return (
        <div className="modal" id="loginPromptModal">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Apply for {props.candidateTitle}</h4>
                        <button ref={closeRef} type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        Please log in or register to apply.
                        <LoginForm onCompleteCallback={callback} redirectToParams={`?id=${props.applyingForID}${props.intranet ? "&s=i" : ""}${props.speculative ? "&s=s" : ""}`} showHeaderTitle={false} />
                    </div>
                </div>
            </div>
        </div>
    );
}